import { useVideoPromotionStore } from '../../../../stores/useVideoPromotionStore'
import { CopyVideosSelection } from '../CopyVideosSelection'

export const PromotionCopyVideoEndscreen = () => {
  const videoPromotionStore = useVideoPromotionStore()

  return (
    <CopyVideosSelection
      value={videoPromotionStore.elementsConfiguration.endScreen.copySource}
      onChange={source => videoPromotionStore.setElementCopySource('endScreen', source)}
    />
  )
}
